<template>
  <div v-if="quota">
    <div v-if="quota.interviews < 1" class="quota-message">
      <div class="quota-message__wrap">
        <div class="quota-message__image-wrap">
          <img class="quota-message__image" :src="img" />
        </div>
        <div class="quota-message__text-wrap">
          <div class="quota-message__top-wrap">
            <div class="quota-message__icon-wrap">
              <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 4.5L15 8.5V5C15 4.45 14.55 4 14 4H7.82L19 15.18V4.5ZM1.27 0L0 1.27L2.73 4H2C1.45 4 1 4.45 1 5V15C1 15.55 1.45 16 2 16H14C14.21 16 14.39 15.92 14.54 15.82L17.73 19L19 17.73L1.27 0Z" fill="white"/>
              </svg>
            </div>
            <div class="quota-message__title">
              {{ $t('exceed') }}
            </div>
          </div>
          <div class="quota-message__subtitle">
            {{ $t('variants') }}:
          </div>
          <div class="quota-message__items">
            <div class="quota-message__item">
              <div class="quota-message__text">
                {{ $t(upgradeMessageType) }}
              </div>
              <button @click="changePlan" class="quota-message__button quota-message__button_plan">
                {{ $t('choose') }}
              </button>
            </div>
            <div class="quota-message__item">
              <div class="quota-message__text">
                {{ $t('wait') }}
                <div>({{ endPeriodText }})</div>
              </div>
              <div class="quota-message__left-days">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="white" xmlns="http://www.w3.org/2000/svg">
                  <path d="M11.99 2C6.47 2 2 6.48 2 12C2 17.52 6.47 22 11.99 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 11.99 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20Z"/>
                  <path d="M12.5 7H11V13L16.25 16.15L17 14.92L12.5 12.25V7Z" />
                </svg>
                {{ $t('leftDays') }}: {{ leftDays }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <slot />
    </div>
  </div>
</template>

<script>
import useAccount from '@/compositions/accounting/useAccount';
import { paymentTabs, settingsTabs } from '@/enums';

export default {
  name: 'InterviewsQuotaExceededCandidate',
  props: {
    upgradeMessageType: {
      type: String,
      default: 'watch',
    },
    img: {
      type: String,
      required: true,
    },
  },
  setup(_, { root: { $router } }) {
    const {
      endPeriodText, leftDays, quota, fetch,
    } = useAccount();
    fetch();
    function changePlan() {
      $router.push({ name: 'settings', params: { type: settingsTabs.PAYMENT, addType: paymentTabs.PLANS } });
    }

    return {
      endPeriodText,
      leftDays,
      changePlan,
      quota,
    };
  },
};
</script>

<style lang="scss" scoped>
.quota-message {
  line-height: 1.375;
  text-align: center;
  color: #FFFFFF;
  font-weight: 400;
  margin-bottom: 1.5rem;
  &__wrap {
    border-radius: 0.25rem;
    overflow: hidden;
    position: relative;
  }
  &__image {
    min-width: 100%;
    min-height: 100%;
  }
  &__image-wrap {
    filter: blur(2rem);
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    position: absolute;
    z-index: 1;
    &:after {
      content: '';
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      position: absolute;
      z-index: 2;
      background: rgba(0, 0, 0, 0.2);
    }
  }
  &__text-wrap {
    padding: 1.375rem 0 2.5rem;
    position: relative;
    z-index: 3;
  }
  &__icon-wrap {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    width: 3rem;
    height: 3rem;
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 50%;
    margin-bottom: 0.875rem;
  }
  &__title {
    font-size: 1.375rem;
    line-height: 1;
    padding: 0 1.5rem;
    margin-bottom: 0.625rem;
  }
  &__subtitle {
    padding: 0 1.5rem;
    margin-bottom: 1.3125rem;
  }

  &__head {
    font-size: 1rem;
    line-height: 1.25;
    font-weight: 600;
    margin-bottom: 0.25rem;
  }
  &__items {
    display: flex;
    align-items: stretch;
  }
  &__item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    width: 50%;
    padding: 0 1.5rem;
    position: relative;
    &:first-child:after {
      content: '';
      width: 1px;
      height: 4.875rem;
      background: rgba(255, 255, 255, 0.2);
      position: absolute;
      top: 0;
      right: 0;
    }
  }
  &__text {
    font-size: 0.9375rem;
    margin-bottom: 1.25rem;
  }
  &__button {
    padding: 0.9375rem 1rem;
    border-radius: 0.25rem;
    &_plan {
      width: 11.875rem;
      background: #1FC57F;
      box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.24);
    }
  }
  &__left-days {
    padding: 0.9375rem 1rem;
    border-radius: 0.25rem;
    border: 1px solid rgba(255, 255, 255, 0.04);
    svg {
      vertical-align: middle;
      margin-right: 0.25rem;
    }
  }
  @media #{map-get($display-breakpoints, 'md-and-down')} {
    .quota-message {
      margin-bottom: 1.25rem;
      &__wrap {
        max-width: 32.5625rem;
        max-height: 22.1875rem;
        margin: 0 auto;
      }
      &__text-wrap {
        padding: 1.125rem 0 2rem;
      }
      &__title {
        font-size: 1.125rem;
        padding: 0 1.125rem;
        margin-bottom: 0.625rem;
      }
      &__subtitle {
        padding: 0 1.125rem;
        margin-bottom: 1.125rem;
      }
      &__item {
        padding: 0 0.75rem;
      }
      &__head {
        font-size: 0.875rem;
        margin-bottom: 0.25rem;
      }
      &__text {
        max-width: 11.25rem;
        font-size: 0.875rem;
        margin: 0 auto 1rem;
      }
      &__button {
        width: auto;
        font-size: 0.875rem;
        padding: 0.625rem 1.125rem;
        line-height: 1.45;
      }
      &__left-days {
        font-size: 0.8175rem;
        padding: 0.625rem 0.5rem;
        line-height: 1.45;
        svg {
          margin-right: 0.125rem;
        }
      }
    }
  }
  @media #{map-get($display-breakpoints, 'xs-only')} {
    .quota-message {
      margin:0 0.625rem 1.25rem;
      &__wrap {
        max-width: 22.5rem;
        max-height: inherit;
        margin: 0 auto;
      }
      &__image {
        min-width: 100%;
        min-height: inherit;
        height: 12.75rem;
      }
      &__image-wrap {
        bottom: inherit;
        height: 12.75rem;
        &:after {
          bottom: inherit;
          height: 12.75rem;
        }
      }
      &__text-wrap {
        padding: 0;
      }
      &__top-wrap {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        height: 12.75rem;
      }
      &__icon-wrap {
        margin-bottom: 0.625rem;
      }
      &__title {
        font-size: 1.125rem;
        line-height: 1.22;
        margin-bottom: 0;
      }
      &__subtitle {
        text-align: left;
        font-size: 0.875rem;
        line-height: 1.3;
        color: #000000;
        background: #FFFFFF;
        padding: 0.625rem 0;
        margin-bottom: 0;
        border-bottom: 1px solid #EEEEEE;
      }
      &__items {
        display: block;
        background: #FFFFFF;
      }
      &__item {
        width: 100%;
        text-align: left;
        align-items: baseline;
        padding: 0.625rem 0 1.25rem;
        border-bottom: 1px solid #EEEEEE;
        &:first-child:after {
          content: none;
        }
      }
      &__head {

      }
      &__text {
        max-width: inherit;
        font-size: 0.875rem;
        color: #000000;
        margin: 0 0 0.625rem;
      }
      &__button {
        min-width: 11.875rem;
      }
      &__left-days {
        min-width: 11.875rem;
        font-size: 0.875rem;
        color: #757575;
        padding: 0.4375rem 0.5rem;
        line-height: 1.45;
        background-color: #EDEDED;
        border-color: #EDEDED;
        svg {
          margin-right: 0.25rem;
          fill: #757575;
        }
      }
    }
  }
}
@media screen and (max-width: 374px) {
  .quota-message {
    &__wrap {
      max-width: 17.75rem;
    }
    &__image {
      height: 10rem;
    }
    &__image-wrap {
      height: 10rem;
      &:after {
        height: 10rem;
      }
    }
    &__top-wrap {
      height: 10rem;
    }
  }
}

</style>

<i18n lang="yml" locale="ru">
  exceed: В вашем тарифе закончились отклики
  variants: Варианты
  leftDays: Осталось дней
  wait: Подождать до начала следующего отчётного периода
  choose: Выбрать тариф
  watch: Перейти на более высокий тариф и посмотреть новые отклики прямо сейчас.
</i18n>
<i18n lang="yml" locale="en">
  exceed: You have exceeded the number of interviews in your plan
  variants: You can
  wait: Wait for the next period to start
  leftDays: Days left
  choose: Choose plan
  watch: Upgrade your plan and see new applicants right now.
</i18n>
